export type WSEvent =
  | { event: 'os-status-changed'; data: { osId: string; newStatus: string } }
  | { event: 'os-opened'; data: { osId: string } }
  // OS excluída pelo backoffice (admin MustAuto) — some das telas.
  | { event: 'os-deleted'; data: { osId: string } }
  // Etapa do módulo (funilaria, estética) — muda sem o status mudar.
  | { event: 'os-stage-changed'; data: { osId: string; stage: string | null } }
  | { event: 'new-media'; data: { osId: string } }
  | { event: 'quote-updated'; data: { osId: string } }
  | { event: 'new-chat-message'; data: { osId: string; messageId: string; senderRole: string; senderName: string; preview: string } }
  | { event: 'slot-status-changed'; data: { osId?: string; slotId?: string | null } };

export type WSStatus = 'connected' | 'connecting' | 'disconnected';

interface WSOptions {
  url: string;
  workshopId: string;
  getToken: () => Promise<string | null>;
  onEvent: (event: WSEvent) => void;
  onStatusChange: (status: WSStatus) => void;
}

export function createWSConnection(opts: WSOptions): () => void {
  let ws: WebSocket | null = null;
  let reconnectTimer: ReturnType<typeof setTimeout> | null = null;
  let destroyed = false;

  function connect() {
    if (destroyed) return;

    opts.onStatusChange('connecting');
    ws = new WebSocket(opts.url);

    ws.onopen = async () => {
      opts.onStatusChange('connected');
      const token = await opts.getToken();
      if (!token) {
        ws?.close();
        return;
      }
      ws?.send(JSON.stringify({ type: 'auth', workshopId: opts.workshopId, token }));
    };

    ws.onmessage = (e) => {
      try {
        const parsed = JSON.parse(e.data as string) as WSEvent;
        opts.onEvent(parsed);
      } catch {
        // ignore malformed messages
      }
    };

    ws.onclose = () => {
      if (destroyed) return;
      opts.onStatusChange('disconnected');
      reconnectTimer = setTimeout(connect, 3000);
    };

    ws.onerror = () => {
      ws?.close();
    };
  }

  connect();

  return () => {
    destroyed = true;
    if (reconnectTimer) clearTimeout(reconnectTimer);
    ws?.close();
  };
}
